const resources = {
  "en": {
    "expensesList": {
      "title": "Expenses",
      "pageDescription": "Review recent spending, narrow the month and category scope, and keep expense cleanup in one place.",
      "filterSummary": "Showing expense activity for {{month}}",
      "pagination": {
        "pageSizeLabel": "Rows shown",
        "allForPeriod": "All for period"
      },
      "metrics": {
        "total": {
          "label": "Total spent",
          "supporting": "Filtered month total"
        },
        "transactions": {
          "label": "Transactions",
          "supporting": "Posted expense rows in scope"
        },
        "categories": {
          "label": "Categories",
          "supporting": "Unique expense categories in view"
        },
        "average": {
          "label": "Average expense",
          "supporting": "Average amount per expense"
        }
      },
      "sections": {
        "recent": {
          "description": "Latest expense rows in the current month and category scope."
        },
        "summary": {
          "description": "Category breakdown for all expense rows that match the current month and category filters.",
          "scopeEmpty": "Summary follows the current month and category filters.",
          "scopeAllVisible": "Summary matches all {{total}} filtered expense rows currently in view.",
          "scopePaginated": "Summary covers all {{total}} filtered expense rows. The list is showing {{rangeStart}}-{{rangeEnd}} on this page."
        }
      },
      "recentTitle": "Recent Transactions",
      "actions": {
        "add": "+ Add",
        "edit": "Edit",
        "assign": "Assign to group",
        "delete": "Delete",
        "cancel": "Cancel",
        "save": "Save",
        "deleteConfirmTitle": "Delete this transaction?",
        "deleteConfirmDescription": "This action cannot be undone.",
        "menuAria": "Transaction actions"
      },
      "list": {
        "empty": "No transactions",
        "unnamed": "Unnamed"
      },
      "modals": {
        "addTitle": "Add Transaction",
        "assignTitle": "Assign to Group",
        "selectGroupPlaceholder": "Select group"
      },
      "includeGoalTransfers": "Include goal transfers",
      "messages": {
        "loadError": "❌ Failed to load transactions",
        "deleteSuccess": "✅ Transaction deleted",
        "errorWithReason": "❌ {{error}}",
        "assigned": "✅ Assigned",
        "categoriesLoadError": "❌ Failed to load categories",
        "groupsLoadError": "❌ Failed to load groups"
      }
    }
  },
  "uk": {
    "expensesList": {
      "title": "Витрати",
      "pageDescription": "Переглядайте недавні витрати, звужуйте місяць і категорію та тримайте cleanup витрат в одному місці.",
      "filterSummary": "Показано витрати за {{month}}",
      "pagination": {
        "pageSizeLabel": "Показувати рядків",
        "allForPeriod": "Усі за період"
      },
      "metrics": {
        "total": {
          "label": "Усього витрачено",
          "supporting": "Підсумок за вибраний місяць"
        },
        "transactions": {
          "label": "Транзакції",
          "supporting": "Проведені витрати у вибірці"
        },
        "categories": {
          "label": "Категорії",
          "supporting": "Унікальні категорії витрат у вибірці"
        },
        "average": {
          "label": "Середня витрата",
          "supporting": "Середня сума однієї витрати"
        }
      },
      "sections": {
        "recent": {
          "description": "Останні витрати у вибраному місяці та категорії."
        },
        "summary": {
          "description": "Розподіл по категоріях для всіх витрат, що відповідають поточним фільтрам місяця та категорії.",
          "scopeEmpty": "Підсумок враховує поточні фільтри місяця та категорії.",
          "scopeAllVisible": "Підсумок збігається з усіма {{total}} відфільтрованими витратами, які зараз показані.",
          "scopePaginated": "Підсумок охоплює всі {{total}} відфільтровані витрати. У списку на цій сторінці показано {{rangeStart}}-{{rangeEnd}}."
        }
      },
      "recentTitle": "Нещодавні транзакції",
      "actions": {
        "add": "+ Додати",
        "edit": "Редагувати",
        "assign": "Призначити до групи",
        "delete": "Видалити",
        "cancel": "Скасувати",
        "save": "Зберегти",
        "deleteConfirmTitle": "Видалити цю транзакцію?",
        "deleteConfirmDescription": "Цю дію не можна скасувати.",
        "menuAria": "Дії з транзакцією"
      },
      "list": {
        "empty": "Немає транзакцій",
        "unnamed": "Без назви"
      },
      "modals": {
        "addTitle": "Додати транзакцію",
        "assignTitle": "Призначити до групи",
        "selectGroupPlaceholder": "Виберіть групу"
      },
      "includeGoalTransfers": "Показувати перекази на цілі",
      "messages": {
        "loadError": "❌ Не вдалося завантажити транзакції",
        "deleteSuccess": "✅ Транзакцію видалено",
        "errorWithReason": "❌ {{error}}",
        "assigned": "✅ Призначено",
        "categoriesLoadError": "❌ Не вдалося завантажити категорії",
        "groupsLoadError": "❌ Не вдалося завантажити групи"
      }
    }
  }
};

export default resources;
